import { createServerFn } from "@tanstack/react-start";
import type { BlogPost, AllPostsPayload, SidebarWidget } from "./types";

export const fetchAllPostsWithCategories = createServerFn({ method: "GET" }).handler(
  async (): Promise<AllPostsPayload> => {
    const { wpListAllPostsWithCategories } = await import("./wp.server");
    return (await wpListAllPostsWithCategories()) ?? { posts: [], categories: [] };
  },
);

export const fetchPostBySlug = createServerFn({ method: "GET" })
  .inputValidator((data: { slug: string }) => {
    if (!data || typeof data.slug !== "string" || data.slug.length > 200) throw new Error("Invalid slug");
    return { slug: data.slug };
  })
  .handler(async ({ data }): Promise<BlogPost | null> => {
    const { wpGetPostBySlug } = await import("./wp.server");
    return wpGetPostBySlug(data.slug);
  });

export const fetchSidebarWidgets = createServerFn({ method: "GET" })
  .inputValidator((data: { sidebar: string }) => {
    if (!data || typeof data.sidebar !== "string" || !/^[a-z0-9-]{1,64}$/.test(data.sidebar)) {
      throw new Error("Invalid sidebar id");
    }
    return { sidebar: data.sidebar };
  })
  .handler(async ({ data }): Promise<SidebarWidget[]> => {
    const { wpListSidebarWidgets } = await import("./wp.server");
    return wpListSidebarWidgets(data.sidebar);
  });
